import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCollectionPreview } from "../../../redux/slices/dashSlice";
import {
  PersonOutlined,
  EmailOutlined,
  PhoneOutlined,
  DescriptionOutlined,
  LocationCityOutlined,
  BusinessOutlined,
  FormatListNumberedOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import LoadingIndicator from "../../utils/LoadingIndicator";

const TopCollection = forwardRef(({search,role,user,from,to,month,year,userOptions, selectedRegion, selectedState, selectedChannels},ref) => {

  const navigate=useNavigate();
  const dispatch = useDispatch();
  const { collectionPreview ,totalCount,getStatus} = useSelector((state) => state.dash);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  useEffect(() => {
    dispatch(fetchCollectionPreview({
      page:page+1,
      rowsPerPage,
       search:search,
       role:role,
      user:  user,
      from:from,
      to:to,
      month:from || to ? null : month,
      year:from || to ? null : year,
      selectedRegion:selectedRegion,
      selectedState:selectedState,
      selectedChannels: selectedChannels
    })); 
  }, [dispatch,page,rowsPerPage,search,role,from,to,user,month,year, selectedRegion, selectedState, selectedChannels]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useImperativeHandle(ref, () => ({
    downloadExcel: () => {
      if (!collectionPreview || collectionPreview.length === 0) return;
  
      const dataToExport = collectionPreview.map((client, index) => ({
        'S.No.': index + 1,
        'Collection': client.collection,
        'No. of times Used': client.total_use,
        'Quotations': client.total_quotation,
        'Products': client.total_sku,
      }));
  
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Clients');
      XLSX.writeFile(wb, 'top_user_quotation.xlsx');
    }
  }));

  return (
    <>
           <LoadingIndicator show={getStatus === "pending"}/>
    
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', borderRadius: 2, overflow: 'hidden' }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-label="client table">
            <TableHead
             sx={{ background: "#04121f", color: "white" }}
            >
              <TableRow>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <FormatListNumberedOutlined /> S. No.
                  </Box>
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <PersonOutlined /> Collection
                  </Box>
                </TableCell>
                
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DescriptionOutlined /> No. of times Used
                  </Box>
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DescriptionOutlined /> Quotations
                  </Box>
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DescriptionOutlined /> Products
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {collectionPreview?.length > 0 ? (
                collectionPreview.map((client, index) => (
                  <TableRow
                    key={`${client.collection}-${index}-${client.total_use}-${client.total_quotation}-${client.total_sku}`}
                    hover
                    sx={{ 
                      '&:nth-of-type(odd)': { backgroundColor: '#f9fafb' },
                      '&:hover': { backgroundColor: '#eef2ff' },
                      transition: 'background-color 0.3s ease',
                      cursor:'pointer',
                    }}
                    onClick={()=>navigate("/admin/collection-skus",{state:{collection:client.collection,role,userOptions:userOptions, user:user,from,to,month,year, selectedRegion, selectedState, selectedChannels}})}
                  >
                    <TableCell sx={{ fontWeight: 'bold', color: '#4c66f5' }}>
                      {(page * rowsPerPage) + index + 1}
                    </TableCell>
                    <TableCell>{client.collection}</TableCell>
                    <TableCell>{client.total_use}</TableCell>
                    <TableCell>{client.total_quotation}</TableCell>
                    <TableCell>{client.total_sku}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="subtitle1" color="text.secondary" sx={{ py: 2 }}>
                      No data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,totalCount||0]}
          component="div"
          count={totalCount || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
    </>
  );
});

export default TopCollection;